import { render } from "./AppLayoutDefault.vue?vue&type=template&id=245e26f4&ts=true"
import script from "./AppLayoutDefault.vue?vue&type=script&lang=ts"
export * from "./AppLayoutDefault.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__